// src/components/ui/PageScaffold.jsx
import React from "react";
import "../../styles/layout.css";

/**
 * PageScaffold
 * - Desktop: Title | [actionsDesktop] | + button
 * - Then hero image
 * - Mobile: [actionsMobile] below hero
 * - Then description
 * - Then page content (children)
 */
export default function PageScaffold({
  title,
   onAdd,                 // () => void (optional)
  heroSrc,
  heroAlt,
  description,           // node or string
  actionsDesktop,        // node
  actionsMobile,         // node
  afterHero,             // node to render directly beneath the hero image
  children,              // page body
}) {
  return (
    <div className="container">
      <div className="header-row scaffold-header">
        <h2>{title}</h2>
        <div className="scaffold-actions-desktop">{actionsDesktop}</div>
        {typeof onAdd === "function" && (
          <button className="btn-add" type="button" onClick={onAdd}>
            +
          </button>
        )}
      </div>

      {heroSrc && (
        <div className="scaffold-hero-wrap">
          <img className="scaffold-hero" src={heroSrc} alt={heroAlt || title} />
        </div>
      )}

      {afterHero ? <div className="scaffold-after-hero">{afterHero}</div> : null}

      <div className="scaffold-actions-mobile">{actionsMobile}</div>

      {description ? <div className="scaffold-desc">{description}</div> : null}

      <div className="scaffold-content">{children}</div>

      <style>{`
        :root { --topbar-h: 56px; }

        .scaffold-header {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }
        .scaffold-header h2 { flex: 1; }

        /* actions placement */
        .scaffold-actions-desktop { display: none; }
        .scaffold-actions-mobile  { display: flex; margin: 8px 0 16px; }
        @media (min-width: 900px) {
          .scaffold-actions-desktop { display: flex; gap: 10px; margin-left: auto; }
          .scaffold-actions-mobile  { display: none; }
        }

        /* hero */
        .scaffold-hero-wrap { margin: 12px 0 8px; }
        .scaffold-hero {
          width: 100%;
          height: 130px;
          object-fit: cover;
          border-radius: 12px;
        }
        @media (max-width: 700px) {
         .scaffold-hero { height: 110px; }
      }

        .scaffold-after-hero { margin: 8px 0 12px; }

        /* description */
        .scaffold-desc {
          color: #2a0516;
          background: #fff;
          border-radius: 10px;
          padding: 8px 0;
          margin-bottom: 8px;
        }
      `}</style>
    </div>
  );
}
